module.exports = __webpack_public_path__ + "static/img/7.90e21e91.png";